import { BaseModel } from '../core/base/base-model';

export type ENTITIY_TYPE = "order" | "fulfillment" | "product" | "variant" | "customer" | "inventory_level" |
  "customer_address"
  | "customer_group" | "customer_group_relationship" |
  "product_collection_relationship" | "shipnow_fulfillment" | "call_log" | "zl_oa_message";

export const ENTITIY_TYPE_MAP = {
  call_log: 'Cuộc gọi',
  zl_oa_message: "ZNS",
}

export class Webhook extends BaseModel {
  id: string;
  entities: ENTITIY_TYPE[];
  fields: string[];
  created_at: string;
  metadata: string;
  states: {
    last_error: {
      error: string;
      resp_body: string;
      resp_status: number;
      sent_at: string;
      retried: number;
    };
    last_sent_at: string;
    state: 'ok' | 'retry' | 'error' | 'stop';
  };
  url: string;
  entities_map: string;
}
